import { Command, CommandResult } from '../procedure.interface';
import { Device } from '@/device';
import { Environment } from '@/enums/environment.enum';
import { IsLegacyDevice } from '@/helpers/device-identifier';
import { InstallProperties } from '@/interfaces/properties.interface';
import { Logger } from '@/logger';

type ProjectType = 'KRYS' | 'OPTICIEN' | 'ORTHO' | 'LENSCAPE' | 'UPDATER';

const SCW_BUCKET = '/proxy/s3/fr.eyesoft.apps';

export class InstallLatestCommand implements Command {
  public project: ProjectType;
  public updateApp: boolean;
  public stopOnError: boolean;
  public type: string;

  constructor(project: ProjectType, updateApp: boolean = false) {
    this.stopOnError = true;
    this.type = 'installLatest';
    this.project = project;
    this.updateApp = updateApp;
  }

  public toLog(): string {
    return `Installing latest ${this.updateApp ? 'update ' : ''}APK for ${this.project}`;
  }

  public async execute(device: Device, logger: Logger, properties?: InstallProperties): Promise<CommandResult> {
    const isLegacy = IsLegacyDevice(device);
    const environment = properties?.environment ?? Environment.PROD;
    const isPreview = properties?.preview === true;
    // Get latest from the server
    const prefix = this.updateApp ? 'UPDATE_' : '';
    let suffix = !isPreview ? '_RELEASE' : '';
    suffix += isLegacy ? '_V1' : '';
    const response = await fetch(
      `${SCW_BUCKET}/${environment.toUpperCase()}/${this.project}/${prefix}${this.project}_${environment.toUpperCase()}${suffix}`,
      { cache: 'no-store' },
    );
    if (!response.ok) {
      return Promise.resolve({
        success: false,
        message: `Failed to fetch latest version for ${this.project} on ${environment.toUpperCase()}`,
      });
    }
    const latestVersion = await response.text();
    const apkPath = `${SCW_BUCKET}/${environment.toUpperCase()}/${this.project}/PICO_${prefix}${this.project}_${environment.toUpperCase()}${suffix}_${latestVersion}.apk`;
    // Generate the URL for the latest APK
    let code = -1;
    try {
      code = await device.installApkFromUrl(apkPath, logger.logProgress('Downloading APK'));
    } catch (error: unknown) {
      return Promise.resolve({
        success: false,
        message: (error as Error).message,
      });
    }
    let apkInfo = `Project: ${this.project}  Env: ${environment.toUpperCase()} (v${latestVersion})`;
    if (isPreview) {
      apkInfo += ' (preview)';
    }
    if (this.updateApp) {
      apkInfo += ' (update app)';
    }
    return Promise.resolve({
      success: code === 0,
      message: code === 0 ? `APK installed (${apkInfo})` : `APK installation failed (${apkInfo})`,
    });
  }
}
